import { render, staticRenderFns } from "./Morder.vue?vue&type=template&id=3b3736ca&"
import script from "./Morder.vue?vue&type=script&lang=js&"
export * from "./Morder.vue?vue&type=script&lang=js&"
import style0 from "./Morder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports